
  import React, { useState, useRef, useMemo, useCallback  } from "react";
  import ToDoListPresenter from "./toDolistPresenter";
  import { useMutation, useQuery } from '@apollo/client';
  import PrintPage from "../common/print_page";
  import {GET_TODOS_AND_CATEGORIES, CREATE_TODO, UPDATE_TODO, DELETE_TODO, REORDER_TODO, MARK_DONE, MARK_NOT_DONE, ASSISTANT_RESPONSE} from '../apis/graphqlQueries';
  import CircularProgress from '@mui/material/CircularProgress'
  import { useLocation } from 'react-router-dom';
  import CompletionNoteDialog from './CompletionNoteDialog';

  function ToDoList(user) {
    
    const location = useLocation();
    const isToDunsPage = location.pathname === '/toduns';

    //convert the user_id to a string
    const user_id = user.sub.split("|")[1];
    const [title, settitle] = useState("");
    const [listName, setlistName] = useState("");
    const [description, setDescription] = useState("");
    
    const [isEdited, setIsEdited] = useState(false);
    const [editedId, setEditedId] = useState(null);
    const [drawerOpen, setDrawer] = useState(false)
    const [dateTimeToDoToDo, setdateTimeToDoToDo] = useState("");
    const [notes, setNotes] = useState([]);
    const [percentDone, setPercentDone] = useState(0);
    const [searchString, setSearchString] = useState("");

    const [toDoToDelete, setToDoToDelete] = useState('');
    const [deleteDialogueOpen, setDeleleteDialogueOpen] = useState(false);
    const [assistantSteps, setassistantSteps] = useState(<CircularProgress/>);
    const [completionNoteDialogOpen, setCompletionNoteDialogOpen] = useState(false);
    const [todoToComplete, setTodoToComplete] = useState(null);
    const [responders, setResponders] = useState([]);
    const [conversation, setConversation] = useState([]);
    const [isDone, setIsDone] = useState(false);

    const [assistantResponse, { ardata, arloading, arerror }] = useMutation(ASSISTANT_RESPONSE);

    const [createTodo, { cdata, cloading, cerror }] = useMutation(CREATE_TODO,{
      refetchQueries: [{ query: GET_TODOS_AND_CATEGORIES, variables: { user_id } }],
    });

    const [updateTodo, { udata, uloading, uerror }] = useMutation(UPDATE_TODO,{
      refetchQueries: [{ query: GET_TODOS_AND_CATEGORIES, variables: { user_id } }],
    });

    const [deleteTodo, { ddata, dloading, derror }] = useMutation(DELETE_TODO,{
      refetchQueries: [{ query: GET_TODOS_AND_CATEGORIES, variables: { user_id } }],
    });

    const [reorderTodo, { rdata, rloading, rerror }] = useMutation(REORDER_TODO,{
      refetchQueries: [{ query: GET_TODOS_AND_CATEGORIES, variables: { user_id } }],
    });

    const [markDone, { mddata, mdloading, mderror }] = useMutation(MARK_DONE,{
      refetchQueries: [{ query: GET_TODOS_AND_CATEGORIES, variables: { user_id } }],
    });

    const [markNotDone, { mnddata, mndloading, mnderror }] = useMutation(MARK_NOT_DONE,{
      refetchQueries: [{ query: GET_TODOS_AND_CATEGORIES, variables: { user_id } }],
    });

    const { loading, error, data } = useQuery(GET_TODOS_AND_CATEGORIES,{
      variables: { user_id },
      notifyOnNetworkStatusChange: true,
    });

    const onTitleChange = useCallback((e) => {
      settitle(e.target.value);
    }, []);

    const onListNameChange = useCallback((e) => {
      setlistName(e.target.value);
    }, []);


    const onDescriptionChange = useCallback((e) => {
      setDescription(e.target.value);
    }, []);

    const onDateToDoToDoChange = useCallback((e) => {
      // store the date as UTC time
      setdateTimeToDoToDo(e.toISOString());
    }, []);

    const onNotesChange = useCallback((index,newNote,isDelete) => {
      if (isDelete){
        setNotes(prevNotes => {
          const updatedNotes = [...prevNotes];
          updatedNotes.splice(index, 1);
          return updatedNotes;
        });
      }else{
        if (index > -1) {
          setNotes(prevNotes => {
            const updatedNotes = [...prevNotes];
            updatedNotes[index] = {title: newNote.title, note: newNote.note, createdDate: newNote.createdDate, isUpdated: true};
            return updatedNotes;
          });
        } else {
          setNotes(prevNotes => [...prevNotes, {title: newNote.title, note: newNote.note, isCreated: true}]);
        }
      }
    }, []);

    const setBlankValues = useCallback(() => {
      settitle("");
      setlistName("");
      setDescription("");
      setdateTimeToDoToDo("");
      setNotes([])
      setPercentDone(0);
      setassistantSteps("")
      setassistantSteps(<CircularProgress/>)
      setResponders([]);
      setConversation([]);
      setIsDone(false);

    }, []);

    const saveTodo = () => {
      if (!isEdited) {
        const newTodoInput = {
          input:{
            title: title,
            description: description,
            listName: listName,
            dateTimeToDoToDo: dateTimeToDoToDo,
            notes: notes,
            isDone: false,
            percentDone: percentDone,
            order: 0,
            user_id: user_id,
          }
          
        };
        createTodo({ variables: newTodoInput }).then(()=>{
          
            setBlankValues()
            setDrawer(false);
          
        });

      } else {
        const cleanedNotes = notes.map(({ __typename, ...rest }) => rest); // Remove __typename cos f**k you graphql
        const updatedTodo = {
          id: editedId,
          input:{
            title: title,
            description: description,
            listName: listName,
            dateTimeToDoToDo: dateTimeToDoToDo,
            percentDone: percentDone,
            notes: cleanedNotes,
            user_id: user_id
          }
        };
        updateTodo({ variables:  updatedTodo }).then(()=>{
          
          setBlankValues()
          setIsEdited(false);
          setDrawer(false);
        
      });
    }
    };
    
    const handleDecision = useCallback((decision) => {
      if (decision){
        const vars = {id:toDoToDelete, user_id:user_id}
        deleteTodo({ variables: vars }).then(
          () => {
            setDeleleteDialogueOpen(false);
            setToDoToDelete('');
          }
        );
      }else{
        setDeleleteDialogueOpen(false);
        setToDoToDelete('');
      };
    }, [toDoToDelete, user_id, deleteTodo]);

    const onDelete = useCallback((id) => {
      setToDoToDelete(id);
      setDeleleteDialogueOpen(true);
    }, []);

    const handleDone = useCallback((id) => {
      // get the checkbox clicked or not
      const checkbox = document.getElementById(id);
      // if it is checked, then show completion note dialog
      if (checkbox.checked) {
        const todo = data ? data.getTodosAndCategories.todos.find((t) => t.id === id) : null;
        setTodoToComplete(todo);
        setCompletionNoteDialogOpen(true);
      } else {
        // if it is unchecked, then mark it as not done
        markNotDone({
          variables: { user_id: user_id, id: id }
        })
      }
    }, [user_id, data, markNotDone]);

    const handleDoneFromDrawer = useCallback((newIsDoneValue) => {
      setIsDone(newIsDoneValue);
      if (newIsDoneValue) {
        // Marking as done - show completion note dialog
        const todo = data ? data.getTodosAndCategories.todos.find((t) => t.id === editedId) : null;
        setTodoToComplete(todo);
        setCompletionNoteDialogOpen(true);
      } else {
        // Marking as not done
        markNotDone({
          variables: { user_id: user_id, id: editedId }
        })
      }
    }, [user_id, data, editedId, markNotDone]);

    const handleCompletionNoteSkip = useCallback(() => {
      if (todoToComplete) {
        markDone({
          variables: { user_id: user_id, id: todoToComplete.id }
        }).then(() => {
          setCompletionNoteDialogOpen(false);
          setTodoToComplete(null);
        });
      }
    }, [todoToComplete, user_id, markDone]);

    const handleCompletionNoteAdd = useCallback((noteText) => {
      if (todoToComplete && noteText.trim()) {
        // Add the completion note to the existing notes
        const cleanedNotes = todoToComplete.notes.map(({ __typename, ...rest }) => rest);
        const updatedNotes = [...cleanedNotes, {
          title: "Completion Note",
          note: noteText,
          isCreated: true
        }];

        // Update the todo with the new note
        const updatedTodo = {
          id: todoToComplete.id,
          input: {
            title: todoToComplete.title,
            description: todoToComplete.description,
            listName: todoToComplete.listName,
            dateTimeToDoToDo: todoToComplete.dateTimeToDoToDo,
            percentDone: todoToComplete.percentDone,
            notes: updatedNotes,
            user_id: user_id
          }
        };

        updateTodo({ variables: updatedTodo }).then(() => {
          // After updating the note, mark as done
          markDone({
            variables: { user_id: user_id, id: todoToComplete.id }
          }).then(() => {
            setCompletionNoteDialogOpen(false);
            setTodoToComplete(null);
          });
        });
      } else {
        // If note is empty, just skip
        handleCompletionNoteSkip();
      }
    }, [todoToComplete, user_id, updateTodo, markDone, handleCompletionNoteSkip]);

    const handleEdit = useCallback((id) => {

      const editVal = data ? data.getTodosAndCategories.todos.find((todo) => todo.id === id) : null;
      setEditedId(editVal.id);
      settitle(editVal.title);
      setlistName(editVal.listName);
      setDescription(editVal.description);
      setdateTimeToDoToDo(editVal.dateTimeToDoToDo);
      setPercentDone(editVal.percentDone);
      setNotes(editVal.notes);
      setResponders(editVal.responders || []);
      setConversation(editVal.conversation || []);
      setIsDone(editVal.isDone || false);
      setIsEdited(true);
      setDrawer(true);

    }, [data]);

    const handleNewToDo = useCallback(() => {
      setBlankValues()
      setIsEdited(false);
      setDrawer(true);
    }, []);

    const closeDrawer = useCallback(() => {
      setDrawer(false);
     // fetchTodos(user_id);
    }, []);

    const changeorder = useCallback((id,increment) => {
      reorderTodo({
        variables: { id: id, user_id: user_id, increment: increment }
      })
    }, [user_id, reorderTodo]);

    const handleFilter = useCallback((str) => {
      setSearchString(str);
    }, []);

    // Helper function to detirmine if a todo date is today or before
    // all dates are utc
    const isTodayOrBefore = (dateTimeString) => {
      return new Date(Date.now()) >= new Date(dateTimeString) || new Date(Date.now()).toDateString() === new Date(dateTimeString).toDateString();
    }  
    const filterTodos = (todos) => {
      // First filter out admin contact form submissions (they appear on the contact page instead)
      // User-created "Contact Us" category todos will still appear here
      const nonContactTodos = todos.filter((todo) =>
        !(todo.isAdminContactTodo === true)
      );

      // Then filter based on the search string
      if (searchString === "Today's Todos"){
          const todaysTodos = nonContactTodos.filter((todo) => isTodayOrBefore(todo.dateTimeToDoToDo));
        return todaysTodos;
      }else{
        if (searchString.length >= 2){
          const filteredTodos = nonContactTodos.filter( (todo) => todo.title?.toLowerCase().search(searchString.toLowerCase()) !== -1 | todo.description?.toLowerCase().search(searchString.toLowerCase()) !== -1 | todo.listName?.toLowerCase().search(searchString.toLowerCase()) !== -1);
          return filteredTodos;
        }else{
          return nonContactTodos;
        }
      }
    }

    const handleAssistantResponse = useCallback((title,description) => {
      setassistantSteps(<CircularProgress/>)
      // assistantResponse
        const newAssistantResponseInput = {
          input:{
            title: title,
            description: description,
            user_id: user_id,
          }

        };
        assistantResponse({ variables: newAssistantResponseInput }).then((res)=>{
          setassistantSteps(res.data.createAssistantResponse.response)
        });
    }, [user_id, assistantResponse]);

    const clearAssistant = useCallback(() => {
      setassistantSteps(<CircularProgress/>)
    }, []);

    const handleConversationUpdate = useCallback(() => {
      // Refetch the todos to get the latest conversation data
      // The refetch will happen automatically via the query
    }, []);

  // Memoize filtered todos to prevent expensive recalculation on every render
  const filteredTodos = useMemo(() => {
    if (!data) return [];
    return filterTodos(data.getTodosAndCategories.todos);
  }, [data, searchString]);

  // Memoize list names to prevent recalculation
  const listNames = useMemo(() => {
    if (!data) return [];
    return data.getTodosAndCategories.categories.map((category) => category.listName);
  }, [data]);

  if (loading) return <CircularProgress />;
  if (error) return <p>Error : {error.message}</p>;

  return (
      data && (
    <div>
      <ToDoListPresenter todos={filteredTodos}
      {...{handleNewToDo,
        drawerOpen,
        onTitleChange,
        onDescriptionChange,
        saveTodo,
        onDelete,
        title,
        listName,
        onListNameChange,
        description,
        dateTimeToDoToDo,
        onDateToDoToDoChange,
        closeDrawer,
        isEdited,
        changeorder,
        handleDone,
        handleEdit,
        notes,
        onNotesChange,
        percentDone,
        setPercentDone,
        handleFilter,
        deleteDialogueOpen,
        setDeleleteDialogueOpen,
        handleDecision,
        handleAssistantResponse,
        assistantSteps,
        clearAssistant,
        listNames,
        isToDunsPage,
        editedId,
        responders,
        conversation,
        handleConversationUpdate,
        isDone,
        handleDoneFromDrawer
      }} />
      <CompletionNoteDialog
        open={completionNoteDialogOpen}
        onSkip={handleCompletionNoteSkip}
        onAddNote={handleCompletionNoteAdd}
      />
      <PrintPage />
      </div>
  )
    );
  }
  
  export default ToDoList;